module.exports = __webpack_public_path__ + "assets/kids/img/logo-kjt.e3a55c6b.png";